import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';

interface InterfaceButton {
    className?: string
    children?: React.ReactNode
    disabled?: boolean
    onClick?: (event: any) => void
}

const ButtonComponent = (props: InterfaceButton) => (
    <button {...props} type="button">
        {props.children}
    </button>
);

export default styled(ButtonComponent)`
    padding: 8px 16px;
    font-size: 0.875rem;
    min-width: 64px;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    min-height: 36px;
    box-sizing: border-box;
    line-height: 1.4em;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    border-radius: 4px;
    opacity: ${({ disabled }) => disabled === true ? 0.5 : 1};
    background-color: ${({ disabled }) => disabled === true ? 'lightgray' : 'white'};
    color: ${({ disabled }) => disabled === true ? 'gray' : Colours.primary};
    border: 1px solid ${({ disabled }) => disabled === true ? 'gray' : Colours.primary50};

    &:hover {
        border: 1px solid ${Colours.primary};
        background-color: ${({ disabled }) => disabled === true ? 'lightgray' : Colours.primary10};
        text-decoration: none;
        cursor: pointer;
    }

    &:active {
        border: 1px solid ${Colours.secondary};
        background-color: ${({ disabled }) => disabled === true ? 'lightgray' : 'white'};
    }
`;


// WEBPACK FOOTER //
// ./src/Components/Button.tsx